<template>
    <div class="topcode-wechat-pay-device-item">
        <span :class="'sign sign-'+info.state">{{'UN_PAID'==info.state?'待付款':'已付款'}}</span>
        <div class="body">
            <div class="left">
                <img :src="imageSrc"/>
            </div>
            <div class="right">
                <div class="header">{{info.name}}</div>
                <div class="row">
                    <label>产品类型</label>
                    <span>{{info.productName}}</span>
                </div>
                <div class="row">
                    <label>设备名称</label>
                    <span>{{info.deviceName}}</span>
                </div>
                <div class="row">
                    <label>设备编号</label>
                    <span>{{info.deviceSn}}</span>
                </div>
            </div>
        </div>
        <div v-if="info.state=='UN_PAID'" class="footer">
            <div style="display: flex;width: 50%;justify-content: center;padding: 10px 0;">
                <div style="font-size: 13px;">实付款：</div>
                <div style="color: red;">¥ {{totalFee}}</div>
            </div>
            <div style="width: 50%;text-align: center;background-color: red;padding: 10px 0;color: #fff;" @click="pay">
                立即支付
            </div>
        </div>
        <div v-else class="footer">
            <div style="display: flex;width: 50%;padding: 10px 16px;">
                <div style="font-size: 13px;">实付款：</div>
                <div style="color: #0DBE4A;">¥ {{totalFee}}</div>
            </div>
        </div>

    </div>
</template>

<script>
    import weChatJsBridge from "@/utils/weChatJsBridge"
    import {downloadImg} from "@/config"
    import {mapGetters} from 'vuex'

    export default {
        props: ['info'],

        computed: {
            imageSrc() {
                return downloadImg + this.info.productImage1
            },
            totalFee() {
                const {totalFee} = this.info;
                return (totalFee / 100).toFixed(2);
            },
            ...mapGetters({openId: 'wechat/openId'})
        },
        methods: {
            pay() {

                const resolve = (ret) => {
                    console.error("支付返回", ret)
                    if (ret.err_msg == "get_brand_wcpay_request:ok") {
                        this.$toast.success("支付成功")
                        setTimeout(() => {
                            this.$emit('reFresh')
                        }, 500);
                    } else {
                        this.$toast.fail("支付失败")

                    }
                }
                this.$http.tokiot.pay.deviceServiceCharge.wxpay
                    .createPrepay({id: this.info.id, tradeType: 'JSAPI', openId: this.openId})
                    .then(ret => {
                        if (ret) {
                            console.error("配置信息", ret)
                            weChatJsBridge.pay(ret, resolve)
                        }
                    })
            },
        }
    }
</script>

<style lang="less" scoped>
    .topcode-wechat-pay-device-item {
        border: 1px #cccccc solid;
        width: 100%;
        background: #fefefe;
        margin-bottom: 8px;
        border-radius: 8px;
        overflow: hidden;

        & > .body {
            display: flex;
            padding: 0px 15px;
            & > .left {
                display: flex;
                flex-direction: column;
                justify-content: center;
                padding-right: 10px;
            }
            & > .right {
                font-size: 14px;
                white-space: normal;
                word-break: break-all;
                & > .header {
                    font-weight: 600;
                }
                & > .row {
                    display: flex;
                    line-height: 1.5;
                    /*align-items: center;*/
                    & > label {
                        width: 75px;
                        flex-shrink: 0;
                        &::after {
                            margin-left: 2px;
                            content: '：';
                        }
                    }
                    & > span {
                        color: #7e7e7e;
                    }
                }
            }
        }
        & > .footer {
            display: flex;
            border-top: 1px solid #f3f3f3;
        }
        & > .sign {
            &.sign-UN_PAID {
                background: red;
            }
            &.sign-PAID {
                background: #0dbe4a;
            }
            font-family: 微软雅黑;
            text-decoration: none;
            display: block;
            position: relative;
            width: 50%;
            height: 25px;
            font-size: 10px;
            /*background-color: red;*/
            color: #fff;
            font-weight: bold;
            line-height: 28px;
            text-align: center;
            transform: translate(-33%, 20%) rotate(-45deg);
            box-shadow: 0 0 5px rgba(0, 0, 0, 0.5), inset 0 0 2px #fff;
            text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);
        }
    }

    img {
        width: 50px;
        height: 50px;
        background: #cccccc;
    }

</style>